import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { API_URL } from "../helpers";
import Alert from "../components/Alert";

const Decline = () => {
  const [alert, setAlert] = useState({
    type: "working",
    text: "",
  });

  const { str } = useParams();

  useEffect(() => {
    const init = async () => {
      const url = new URL(`${API_URL}/guestDeclineInit`);
      const params = {
        id: str ? str : "",
      };
      url.search = new URLSearchParams(params);

      try {
        const response = await fetch(url, {
          method: "GET",
          cache: "no-store",
        });
        const json = await response.json();
        if (json && json.resp === 1) {
          setAlert({
            type: "success",
            text: json.text,
          });
        } else {
          setAlert({
            type: json.resp === 2 ? "notice" : "error",
            text: json.text,
          });
        }
      } catch (error) {
        setAlert({
          type: "error",
          text: "An error has occurred.",
        });
      }
    };

    init();

    // eslint-disable-next-line
  }, []);

  return <Alert data={alert} />;
};

export default Decline;
